/* eslint-disable import/extensions */
import Lottie from 'lottie-react';
import eddyAnimation from '@/client/assets/lottie/eddy.json';
import eddyThinkingAnimation from '@/client/assets/lottie/eddyThinking.json';

interface EddyAnimationProps {
  size: number;
  isThinking?: boolean;
}

export default function EddyAnimation({ size, isThinking = false }: EddyAnimationProps) {
  return (
    <Lottie
      animationData={isThinking ? eddyThinkingAnimation : eddyAnimation}
      style={{ marginLeft: isThinking ? 1 : 0, margin: 0, padding: 0, height: size, width: size }}
    />
  );
}
